import React from 'react';
import BaseComponent from "../../BaseComponent";
import Axios from "axios";
import {API, ENDPOINTS} from "../../../network/API";
import LoadingSpinner from "../../common/LoadingSpinner";

import "./WasteProcedureListComponent.css";
import ScreenTitleComponent from "../common/ScreenTitleComponent";
import MediaViewerPDFComponent from "../specifications/media/MediaViewerPDFComponent";
import MediaViewerAudioComponent from "../specifications/media/MediaViewerAudioComponent";
import MediaViewerYouTubeComponent from "../specifications/media/MediaViewerYouTubeComponent";
import {WasteProcedure} from "../../../data/WasteProcedure";

export default class WasteProcedureDetailComponent extends BaseComponent {

    constructor(props, context) {
        super(props, context);

        let wasteProcedureId = this.getUriProperty("id", null);

        this.initState({
            wasteProcedureId,
            wasteProcedure : null,
            wasteProcedureNetworkInFlight : false
        });
    }

    componentDidMount() {
        this.getWasteProcedureFromNetwork();

        window._epShowSiteChangeButton(false);
    }

    componentWillUnmount() {
        window._epShowSiteChangeButton(true);
    }

    getWasteProcedureFromNetwork = () => {
        if (this.state.wasteProcedureNetworkInFlight) return;

        this.setState({
            wasteProcedureNetworkInFlight : true
        });

        let formData = new FormData();
        formData.append("wasteProcedureId", this.state.wasteProcedureId);

        Axios.post(ENDPOINTS.wasteProcedure.getWasteProcedure, formData)
            .then((r) => {
                let wasteProcedure = null;

                let resp = API.parse(r);
                if (resp.success) {
                    wasteProcedure = resp.data.wasteProcedure;
                } else {
                    this.showError(API.formatError(resp));
                }

                this.setState({
                    wasteProcedureNetworkInFlight : false,
                    wasteProcedure
                })
            })
            .catch((e) => {
                this.showError("An unknown error has occurred. Please reload the page. [A3000]")
            });
    }

    showError = (message) => {
        this.props.showModal("Error", message);
    }

    wrapMediaElement = (element) => {
        return (
            <div className={"row"}>
                <div className={"hidden-xs col-md-2 col-lg-3"} />
                <div className={"col-12 col-md-8 col-lg-6"}>
                    {element}
                </div>
            </div>
        );
    }

    render() {
        let screenTitle = "";
        let specificationItems = [];

        if (!this.state.wasteProcedureNetworkInFlight && this.state.wasteProcedure != null) {
            let proc = this.state.wasteProcedure;

            screenTitle = proc.title;

            if (proc.media !== undefined) {
                proc.media.forEach((media) => {
                    let mediaType = parseInt(media.wasteProcedureMediaTypeId);

                    if (mediaType === WasteProcedure.MEDIA_TYPES.PDF) {
                        specificationItems.push(
                            this.wrapMediaElement(
                                <MediaViewerPDFComponent
                                    mediaUrl={media.mediaPath} />
                            )
                        )
                    } else if (mediaType === WasteProcedure.MEDIA_TYPES.AUDIO) {
                        specificationItems.push(
                            this.wrapMediaElement(
                                <MediaViewerAudioComponent
                                    mediaUrl={media.mediaPath}
                                    mimeType={media.mimeType} />
                            )
                        )
                    } else if (mediaType === WasteProcedure.MEDIA_TYPES.VIDEO) {
                        specificationItems.push(
                            this.wrapMediaElement(
                                <MediaViewerYouTubeComponent
                                    videoId={media.mediaPath} />
                            )
                        )
                    }
                });
            }

            if (specificationItems.length === 0) {
                specificationItems.push(
                    <div className={"row mt-4"}>
                        <div className={"col-12 text-center"}>
                            <em>No media to display</em>
                        </div>
                    </div>
                )
            }
        } else {
            specificationItems = (
                <div className={"row"}>
                    <div className={"col-12"}>
                        <LoadingSpinner key={"loading"} />
                    </div>
                </div>
            )
        }

        return (
            <div className={"container waste-procedure-detail-component"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <ScreenTitleComponent title={screenTitle} history={this.props.history} />
                    </div>
                </div>

                {specificationItems}
            </div>
        )
    }

}